exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".j-vxe-radio.no-animation .ant-radio-inner,\n.j-vxe-radio.no-animation .ant-radio-inner::after {\n  -webkit-transition: none !important;\n  transition: none !important;\n}\n", ""]);

// exports
